import Vue from 'vue'
import Router from 'vue-router'
import VueCarousel from 'vue-carousel'
import VeeValidate from 'vee-validate'
import LandingComponent from '@/components/LandingComponent'
import AboutComponent from '@/components/AboutComponent'
import ProductsComponent from '@/components/ProductsComponent'
import ProductDetailComponent from '@/components/ProductDetailComponent'
import NewsComponent from '@/components/NewsComponent'
import NewsDetailComponent from '@/components/NewsDetailComponent'
import ContactComponent from '@/components/ContactComponent'
import LoginComponent from '@/components/LoginComponent'
import RegisterComponent from '@/components/RegisterComponent'
import SearchComponent from '@/components/SearchComponent'

Vue.use(Router)
Vue.use(VueCarousel)
Vue.use(VeeValidate)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: LandingComponent
    },
    {
      path: '/about',
      name: 'About',
      component: AboutComponent
    },
    {
      path: '/products',
      name: 'Products',
      component: ProductsComponent
    },
    {
      path: '/products/:id',
      name: 'Product Detail',
      component: ProductDetailComponent
    },
    {
      path: '/news',
      name: 'News',
      component: NewsComponent
    },
    {
      path: '/news/:id',
      name: 'News Detail',
      component: NewsDetailComponent
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactComponent
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginComponent
    },
    {
      path: '/register',
      name: 'Register',
      component: RegisterComponent
    },
    {
      path: '/search/:search',
      name: 'Search Results',
      component: SearchComponent
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js